import http from './http'

export default {
  getCalculator: eventId => http.get(`/v2/events/${eventId}/calculator`),
  createCalculator: (eventId, data) => http.post(`/v2/events/${eventId}/calculator`, data, { silent: true }),
  updateCalculator: (calculatorId, data) => http.patch(`/v2/calculators/${calculatorId}`, data, { silent: true }),
  getDraftPrizeSummary: draftId => http.get(`/v2/drafts/${draftId}/prize-summary`)
}



// WEBPACK FOOTER //
// ./src/services/api/calculators.js